<template>
	<div :class="['buy-item',{'got': $attrs.drawn,'gray':isGray}]">
		<Item
			v-bind="$attrs"
			type="buy"
			v-on="$listeners"
		></Item>
		<div class="discount">
			<Marquee :text="transify.BUY_PRICE" class="txt"></Marquee>
			<Gems :gems="$attrs.gems"></Gems>
		</div>
		<div class="origin">
			<Marquee :text="transify.BUY_ORIGIN_PRICE" class="txt"></Marquee>
			<Gems :gems="$attrs.original_price" type="origin-gems"></Gems>
		</div>
	</div>
</template>
<script>
import Item from '@/components/item/index.vue'
import Gems from '@/components/gems/index.vue'
export default{
	name: "Buyitem",
	data(){
		return{}
	},
	inheritAttrs: false,
	methods: {
	},
	components:{
		Item,
		Gems
	},
	computed:{
		transify(){
			return this.$bus.$data.transify
		},
		isGray(){
			return this.$attrs.wantBuy&&Object.keys(this.$attrs.wantBuy).length>0&&this.$attrs.wantBuy.pk!=this.$attrs.pk
		}
	}
}
</script>
<style lang="scss" scoped>
.buy-item{
	@include flexcc;
	@include res-size(
		$margin-bottom: 20px
	);
	.origin,.discount{
		@include flexrc;
		flex-wrap: nowrap;
		.txt{
			@include res-size(
				$width: 125px,
				$font-size: 22px
			)
		}
	}
	.origin{
		position: relative;
		color: #5da5ab;
		.txt{
			@include res-size(
				$width: 105px,
				$font-size: 22px
			)
		}
		&::after{
			position: absolute;
			content: "";
			width: 110%;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-200%);
			background-color: #af1b1b;
			height: 2px;
		}
	}
	.discount{
		color: #ffd65f;
		@include res-size(
			$height: 40px,
			$margin-top: 10px
		)
	}
}
.buy-item.got,.buy-item.gray{
	@include gray
}
</style>


// WEBPACK FOOTER //
// src/components/buyitem/index.vue